import localFont from 'next/font/local'
import Head from 'next/head'

import { APP_ENV } from '@/config/env'

// Fonts to prefetch are chosen based on the font files that are loaded on the index page. We might need to update this
// list as content is adjusted and different font types are required.
const adieuBold = localFont({
  src: '../../../../packages/ui-kit/src/assets/fonts/web/Adieu-Bold.woff2',
  display: 'block',
  fallback: ['sans-serif'],
  preload: true,
})
const adieuRegular = localFont({
  src: '../../../../packages/ui-kit/src/assets/fonts/web/Adieu-Regular.woff2',
  display: 'block',
  fallback: ['sans-serif'],
  preload: false,
})
const modernEraMedium = localFont({
  src: '../../../../packages/ui-kit/src/assets/fonts/web/ModernEra-Medium.woff2',
  fallback: ['sans-serif'],
  display: 'block',
  preload: true,
})
const modernEraRegular = localFont({
  src: '../../../../packages/ui-kit/src/assets/fonts/web/ModernEra-Regular.woff2',
  fallback: ['sans-serif'],
  display: 'block',
  preload: true,
})
const modernEraBold = localFont({
  src: '../../../../packages/ui-kit/src/assets/fonts/web/ModernEra-Bold.woff2',
  fallback: ['sans-serif'],
  display: 'block',
  preload: false,
})

export const CustomHead = () => {
  return (
    <Head>
      {/* default title it should be overridden by the page title */}
      <title>Getsafe</title>
      <style
        dangerouslySetInnerHTML={{
          __html: `
      .async-hide { opacity: 0 !important}
    `,
        }}
      />

      {APP_ENV !== 'production' && <meta name="robots" content="noindex" />}
      <meta charSet="utf8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <meta name="msapplication-TileColor" content="#da532c" />
      <meta name="theme-color" content="#ffffff" />
      <meta name="facebook-domain-verification" content="qdzojka9h2dtq9v6yc0in85gu24rcj" />

      {adieuBold.style.fontStyle}
      {adieuRegular.style.fontStyle}
      {modernEraMedium.style.fontStyle}
      {modernEraRegular.style.fontStyle}
      {modernEraBold.style.fontStyle}

      {APP_ENV === 'production' ? (
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"187003321", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");`,
          }}
        />
      ) : null}
    </Head>
  )
}
